import { render } from "./AppTopbar1.vue?vue&type=template&id=ed683510"
import script from "./AppTopbar1.vue?vue&type=script&lang=js"
export * from "./AppTopbar1.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__